import { useLocation } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();
  
  return (
    <div className="relative flex flex-col items-center justify-center h-screen text-center px-4">
      <h1 className="absolute bottom-0 text-9xl md:text-[12rem] font-black text-gray-50 select-none pointer-events-none z-0">
        404
      </h1>
      <div className="relative z-10">
        <h1 className="text-xl md:text-2xl font-semibold mt-6">ページが見つかりません</h1>
        <p className="mt-2 text-base text-gray-400 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base md:text-lg text-gray-500">URLをご確認いただくか、トップページからお探しください。</p>
        <a href="/" className="mt-6 inline-flex rounded-md bg-blue-600 px-5 py-3 font-semibold text-white hover:bg-blue-700">
          トップページへ戻る
        </a>
      </div>
    </div>
  );
}
